<template>
  <div
    class="flex w-full h-full fixed z-50 top-0 left-0 justify-center overflow-y-scroll"
    :class="{ 'pointer-events-none': !models.length }"
    @click="handleCloseAll"
  >
    <TransitionGroup
      name="modal"
      @before-leave="beforeLeave"
      @leave="leave"
      @click.native="handleCloseAll"
      tag="div"
      class="absolute flex flex-col min-h-full items-stretch justify-center"
    >
      <BlockModal
        class="modal-item"
        v-for="model in models"
        :key="model.uuid"
        :modal="model"
      />
    </TransitionGroup>
  </div>
</template>

<script>
import BlockModal, { instagram, mailingList, contact } from "./BlockModal";
import { mapState } from "vuex";

export function handleFollow() {
  this.$store.commit("addModal", instagram);
  this.$store.commit("addModal", mailingList);
}

export function handleContact() {
  this.$store.commit("addModal", contact);
}

export default {
  name: "BlockModalContainer",

  components: {
    BlockModal
  },

  computed: {
    ...mapState({
      models: state => state.ui.modals
    })
  },

  methods: {
    handleCloseAll(e) {
      if (e.target === e.currentTarget) this.$store.commit("removeAllModals");
    },
    beforeLeave(el) {
      el.style.height = `${el.offsetHeight}px`;
      el.style.opacity = "1";
    },
    leave(el) {
      // Don't know why this has to be in both hooks
      el.style.height = `${el.offsetHeight}px`;
      el.style.opacity = "1";

      el.style.height = "0px";
      el.style.opacity = "0";
    }
  }
};
</script>

<style scoped>
.modal-item {
  transition: opacity var(--transition-short) 0s,
    height var(--transition-short) 0.15s;
  transition-timing-function: var(--transition-ease-in);
  overflow: hidden;
}
</style>
